'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var ToolbarInternal = function ToolbarInternal(_ref) {
  var children = _ref.children,
      className = _ref.className,
      clear = _ref.clear,
      filters = _ref.filters,
      title = _ref.title,
      onChange = _ref.onChange;

  var _useState = React.useState(filters.map(function (item) {
    return {
      id: item.id,
      selected: false
    };
  })),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      filterStatus = _useState2[0],
      setFilterStatus = _useState2[1];

  var isClearDisabled = filterStatus.every(function (item) {
    return !item.selected;
  });

  var onClickFilter = function onClickFilter(e) {
    var filterId = e.target.dataset.filterId;
    setFilterStatus(filterStatus.map(function (item) {
      return item.id === filterId ? _rollupPluginBabelHelpers.objectSpread2({}, item, {
        selected: !item.selected
      }) : item;
    }));
  };

  var onClickClear = function onClickClear() {
    setFilterStatus(filterStatus.map(function (item) {
      return _rollupPluginBabelHelpers.objectSpread2({}, item, {
        selected: false
      });
    }));
  };

  React.useEffect(function () {
    onChange(filterStatus);
  }, [filterStatus]);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ds-organisms-toolbar-internal ".concat(className)
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ds-organisms-toolbar-internal-left-content"
  }, title, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ds-organisms-toolbar-internal-filter"
  }, filters.map(function (item, index) {
    return /*#__PURE__*/React__default['default'].createElement("button", {
      className: "ds-organisms-toolbar-internal-filter-item ".concat(filterStatus[index] && filterStatus[index].selected ? 'selected' : ''),
      "data-filter-id": item.id,
      key: "filter-".concat(item.id),
      onClick: onClickFilter,
      type: "button"
    }, item.name);
  }), /*#__PURE__*/React__default['default'].createElement("button", {
    className: "ds-organisms-toolbar-internal-filter-clear ".concat(isClearDisabled ? 'disabled' : ''),
    disabled: isClearDisabled,
    onClick: onClickClear,
    type: "button"
  }, clear))), children);
};

ToolbarInternal.propTypes = {
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].string,
  clear: PropTypes__default['default'].string.isRequired,
  filters: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
    id: PropTypes__default['default'].string,
    name: PropTypes__default['default'].string
  })).isRequired,
  title: PropTypes__default['default'].string.isRequired,
  onChange: PropTypes__default['default'].func.isRequired
};
ToolbarInternal.defaultProps = {
  children: null,
  className: ''
};

module.exports = ToolbarInternal;
